export const experienceInfo = [
    {
        title: "IoT Database Programmer @ The Leahy Center",
        status: "Currently Working There",
        DescriptionPoints: [
            "Maintaining a database of Internet of Things (IoT) devices.",
            "Building responsive, user-friendly, and modern interfaces using React, Next.js, TypeScript, and Tailwind CSS.",
            "Integrating CI/CD pipelines to automate testing, linting, and deployment processes, ensuring high-quality code delivery.",
            "Implementing backend integration tests with Jest and Prisma to ensure proper database and backend functionality.",
            "Implementing frontend Unit and End-to-End tests with Jest, React Testing Library, and Playwright to ensure user workflows remain functional across browsers and application changes.",
        ]
    },
    {
        title: "Programming Tutor @ Champlain College SMART Space",
        status: "Currently Working There",
        DescriptionPoints: [
            "SMART Space peer tutor for CSI-related courses.",
            "Helping tutees develop learning stronger and personalized learning strategies and habits."
        ]
    },
    {
        title: "IT Administration Intern @ The Leahy Center",
        status: "Already Completed",
        DescriptionPoints: [
            "Engaged in hands-on work in a professional setting, learning computer system management/installation and networking.",
            "Shadowed Isaiah River (Dev Ops) and Kiyan Pourmaleki (IoT database), gaining knowledge of the troubleshooting process and the workflow at The Leahy Center.",
        ]
    },
    {
        title: "Three.JS Journey Member/Student",
        status: "Already Completed",
        DescriptionPoints: [
            "Learning Three.js and React Three Fiber through Bruno Simon's course, creating awesome 3D web experiences, and engaging in the community competitions."
        ]
    }
]